/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import React, { Component } from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'

// store
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import store from '../store'

import SimpleBottomNavigation from '../components/BottomNavigation'
import ClassificationWrapper from '../components/ClassificationWrapper/ClassificationWrapper'

//routes
import Router from './Router'

// theme
import blue from '@material-ui/core/colors/blue'
import lightBlue from '@material-ui/core/colors/lightBlue'

// App theme
import './App.css'

const theme = {
    typography: {
    },
    palette: {
        primary: blue,
        secondary: lightBlue
    },
    status: {
        danger: 'orange'
    },
}
const defTheme = createMuiTheme(theme)

class App extends Component {
    render() {
        return (
            <Provider store={ store }>
                <MuiThemeProvider theme={ defTheme }>
                    <CssBaseline>
                        <ClassificationWrapper level={"UNCLASSIFIED // CUI"}>
                            <BrowserRouter basename='/'>
                                <Router />
                            </BrowserRouter>
                            <SimpleBottomNavigation />
                        </ClassificationWrapper>
                    </CssBaseline>
                </MuiThemeProvider>
            </Provider>
        )
    }
}

export default App
